"use client";

import { useState } from "react";
import { ToolbarButton } from "@/components/resumeEditor/FloatingToolbar";

export default function FieldVisibilityControl({
  fields,
  hiddenFields,
  onToggleField,
}: {
  fields: { key: string; label: string }[];
  hiddenFields: string[];
  onToggleField: (fieldKey: string) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <ToolbarButton label="Field visibility" onClick={() => setOpen((o) => !o)}>
        <span aria-hidden="true">⚙</span>
      </ToolbarButton>
      {open ? (
        <div className="absolute left-1/2 top-full z-30 mt-2 w-48 -translate-x-1/2 rounded-xl border border-slate-200 bg-white p-3 text-left text-slate-700 shadow-xl dark:border-slate-700 dark:bg-[#0f172a]">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-400 dark:text-slate-500">
            Show fields
          </p>
          <div className="space-y-1.5">
            {fields.map((field) => (
              <label
                key={field.key}
                className="flex items-center gap-2 text-xs text-slate-600 dark:text-slate-300"
              >
                <input
                  type="checkbox"
                  checked={!hiddenFields.includes(field.key)}
                  onChange={() => onToggleField(field.key)}
                />
                {field.label}
              </label>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
